import imageToURI from "image-to-data-uri";
import React, { useState } from "react";

import {
  BlurOverlayImage,
  ImageContent,
  ImageWrapPosition,
} from "./ImageItem.styled";
import MiddleTag from "./MiddleTag";

const ImageItem = (props) => {
  const [base64Convert, setBase64Convert] = useState(false);
  /* 
      여기서 아래 이미지 src 에 1x1 사이즈 투명 png 파일의 data URI 값을
      넣어주는 이유는 로컬 주소가 아닌 이미지를 넣는 경우 chrome 에서는
      보안이슈가 없지만, safari 에서는 보안이슈로 인해 이미지를 canvas 로
      로딩할때 애러를 내고 멈추기 때문이다. 아래 코드에서 dataURI 로 변경해서
      이미지 로드시 대체해 줬지만 htmltoimage 패키지가 toPng 를 실행하는
      과정에서 이미지의 기본 src 를 참조하는 로직인듯 하여 사파리에서 그런
      애러가 뜨고 결국 embed 되지 않은 항목을 캡춰하지 못하는게 그간의 이미지
      캡춰 실패의 이유였다.
  */
  return (
    <ImageWrapPosition pos={props.data.pos} className="image-contents-list">
      {props.data.imageInfo.blur && <BlurOverlayImage data={props.data} />}
      {props.data.imageInfo.middleTagArray &&
        props.data.imageInfo.middleTagArray.map((middleTagItem, idx) => (
          <MiddleTag data={middleTagItem} key={idx} />
        ))}

      <ImageContent
        data={props.data}
        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR4nGP4//8/AwAI/AL+p5qgoAAAAABJRU5ErkJggg=="
        alt={props.data.title}
        width="100%"
        id={`${props.data.sno}-${props.data.id}_target_image`}
        onLoad={() => {
          if (!base64Convert) {
            imageToURI(`${props.data.imageInfo.src}`, (err, uri) => {
              const targetImage = document.getElementById(
                `${props.data.sno}-${props.data.id}_target_image`
              ) as HTMLImageElement;
              if (targetImage) {
                targetImage.src = uri;
                setBase64Convert(true);
              }
            });
          }
        }}
      />
    </ImageWrapPosition>
  );
};

export default ImageItem;



// WEBPACK FOOTER //
// ./src/components/preview/ImageItem.tsx